<template>
  <div class="modal-dialog">
    <div class="modal-content border-0">
      <div class="modal-header px-4">
        <h5 class="modal-title" :class="isMobile && 'font-weight-bold'">
          <span class="dot text-center bg-orange mr-3 shadow">
            <i
              aria-hidden="true"
              class="fa fa-calendar-plus orange-icon text-white font-14"
            />
          </span>
          Añadir Espacio Disponible
        </h5>
      </div>
      <validation-observer ref="formRef" novalidate>
        <div class="modal-body px-4" :class="isCustom && 'scrollable'">
          <div class="px-2">
            <div class="mt-4">
              <validation-provider rules="required">
                <div class="font-14 color-gray-6 mb-1">
                  Día(s) de la semana:
                </div>
                <div class="d-flex flex-wrap">
                  <div
                    v-for="(item, index) in days"
                    :key="`day-${index}`"
                    class="mr-3"
                  >
                    <CheckBox v-model="item.selected" @input="handleCheck" />
                    <span class="ml-1">{{ item.name }}</span>
                  </div>
                </div>
                <error
                  v-if="!hasDaysSelected && submitted"
                  :message="'Favor seleccionar al menos un dia de la semana.'"
                  variant="no-border"
                />
              </validation-provider>
            </div>
            <div class="mt-4">
              <div class="font-14 color-gray-6 mb-1">
                Horario Disponible:
              </div>
              <validation-provider
                v-slot="{ errors }"
                class="w-100"
                rules="required"
              >
                <custom-radio
                  id="availableHours"
                  ref="availableHoursRef"
                  v-model="model.availableHours"
                  class="ml-n3"
                  custom-error-msg="El horario disponible es requerido"
                  :error="Boolean(errors[0])"
                  is-inline
                  name="availableHours"
                  :options="availableHoursOptions"
                  @input="changeAvailableHours"
                />
              </validation-provider>
            </div>
            <div class="dropdown-divider mt-5 mb-4" />
            <div v-if="isCustom">
              <div v-for="item in model.daysSelected" :key="item.day">
                <span
                  class="badge badge-pill badge-secondary mt-3 mb-2 custom-badge font-16"
                >
                  {{ item.dayName }}
                </span>
                <div>
                  <div class="font-14 color-gray-6 mb-1">
                    Horario Comienzo:
                  </div>
                  <div class="d-flex">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-input
                        v-model="item.model.from.hour"
                        class="input-time-size"
                        custom-error-msg="El horario de comienzo es requerido"
                        :error="errors[0]"
                        mask-type="Day"
                        type="text"
                        @input="() => evalEnterHour(item.model)"
                      />
                    </validation-provider>
                    <span class="mr-3 mt-1">:</span>
                    <validation-provider
                      v-slot="{ errors, failedRules }"
                      rules="required|quater"
                    >
                      <custom-input
                        v-model="item.model.from.minute"
                        class="input-time-size"
                        :custom-error-msg="
                          failedRules.quater
                            ? 'Valores permitidos en intervalos de 5 minutos.'
                            : ''
                        "
                        :error="errors[0]"
                        mask-type="Day"
                        type="text"
                        @input="() => evalEnterMinute(item.model)"
                      />
                    </validation-provider>
                    <b-form-select
                      v-model="item.model.from.ampm"
                      class="input-time-ampm-size"
                      :disabled="isDisabled(item.model.from)"
                      :options="timeOptions"
                    />
                  </div>
                </div>
                <div class="mt-4">
                  <div class="font-14 color-gray-6 mb-1 mt-4">
                    Horario Finalización:
                  </div>
                  <div class="d-flex position-relative">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-input
                        v-model="item.model.to.hour"
                        class="input-time-size"
                        :class="errors[0] && 'mb-4'"
                        custom-error-msg="El horario de finalizacion es requerido"
                        :error="errors[0]"
                        mask-type="Day"
                        type="text"
                        @input="() => evalEndEnterHour(item.model)"
                      />
                    </validation-provider>
                    <span class="mr-3 mt-1">:</span>
                    <validation-provider
                      v-slot="{ errors, failedRules }"
                      rules="required|quater"
                    >
                      <custom-input
                        v-model="item.model.to.minute"
                        class="input-time-size"
                        :custom-error-msg="
                          failedRules.quater
                            ? 'Valores permitidos en intervalos de 5 minutos.'
                            : item.model.to.hour
                            ? 'Los minutos son requeridos'
                            : ''
                        "
                        :error="errors[0]"
                        mask-type="Day"
                        type="text"
                      />
                    </validation-provider>
                    <b-form-select
                      v-model="item.model.to.ampm"
                      class="input-time-ampm-size"
                      :disabled="isDisabled(item.model.to)"
                      :options="timeOptions"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div>
                <div class="font-14 color-gray-6 mb-1">
                  Horario Comienzo:
                </div>
                <div class="d-flex">
                  <validation-provider
                    v-slot="{ errors, failedRules }"
                    name="HourStartHour"
                    rules="required"
                  >
                    <custom-input
                      v-model="from.hour"
                      class="input-time-size"
                      :custom-error-msg="
                        failedRules.required
                          ? 'El horario de comienzo es requerido'
                          : 'El horario de comienzo empieza a las 7:00 AM'
                      "
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                      @input="() => evalEnterHour({ from, to })"
                    />
                  </validation-provider>
                  <span class="mr-3 mt-1">:</span>
                  <validation-provider
                    v-slot="{ errors, failedRules }"
                    name="HourStartMinute"
                    rules="required|quater"
                  >
                    <custom-input
                      v-model="from.minute"
                      class="input-time-size"
                      :custom-error-msg="
                        failedRules.quater
                          ? 'Valores permitidos en intervalos de 5 minutos.'
                          : from.hour
                          ? 'Los minutos son requeridos'
                          : ''
                      "
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                      @input="() => evalEnterMinute({ from, to })"
                    />
                  </validation-provider>
                  <b-form-select
                    v-model="from.ampm"
                    class="input-time-ampm-size"
                    :disabled="isDisabled(from)"
                    :options="timeOptions"
                  />
                </div>
              </div>
              <div class="mt-4">
                <div class="font-14 color-gray-6 mb-1 mt-4">
                  Horario Finalización:
                </div>
                <div class="d-flex position-relative">
                  <validation-provider
                    v-slot="{ errors }"
                    name="HourEndHour"
                    rules="required"
                  >
                    <custom-input
                      v-model="to.hour"
                      class="input-time-size"
                      :custom-error-msg="
                        'El horario de finalización es requerido'
                      "
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                      @input="() => evalEndEnterHour({ to })"
                    />
                  </validation-provider>
                  <span class="mr-3 mt-1">:</span>
                  <validation-provider
                    v-slot="{ errors, failedRules }"
                    name="HourEndMinute"
                    rules="required|quater"
                  >
                    <custom-input
                      v-model="to.minute"
                      class="input-time-size"
                      :custom-error-msg="
                        failedRules.quater
                          ? 'Valores permitidos en intervalos de 5 minutos.'
                          : to.hour
                          ? 'Los minutos son requeridos'
                          : ''
                      "
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>
                  <b-form-select
                    v-model="to.ampm"
                    class="input-time-ampm-size"
                    :disabled="isDisabled(to)"
                    :options="timeOptions"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center mt-3">
          <action-button
            id="calendar-filter-apply-btn"
            variant="outline-danger px-3 mr-2"
            @click="close"
          >
            <i aria-hidden="true" class="fa fa-times-circle" />
            Cancelar
          </action-button>
          <action-button
            id="calendar-filter-apply-btn"
            variant="success px-3"
            @click="save"
          >
            <i aria-hidden="true" class="fa fa-calendar-plus mr-2" />
            Crear Disponibilidad
          </action-button>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomRadio from 'custom-radio';
import CheckBox from 'CheckBox';
import Error from 'custom-error';
import CustomInput from 'CustomInput';
import moment from 'moment';
import 'moment/locale/es-do';
import typeSpace from '@/utils/constants/typeSpace.js';
import availableHours from '@/utils/constants/availableHours.js';
import alertMixin from '@/mixins/alert.mixin';
import { extend } from 'vee-validate';

extend('quater', {
  validate: (value) => {
    return value % 15 === 0;
  },
  message: 'El horario seleccionado no es válido.',
});

export default {
  name: 'AddAvailableSpace',
  components: {
    ActionButton,
    CustomRadio,
    CheckBox,
    Error,
    CustomInput,
  },
  mixins: [alertMixin],
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    modelEdit: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    submitted: false,
    from: {
      hour: null,
      minute: null,
      ampm: null,
    },
    to: {
      hour: null,
      minute: null,
      ampm: null,
    },
    model: {
      typeSpace: null,
      availableHours: null,
      daysSelected: [],
    },
    days: [
      {
        id: 0,
        name: 'L',
        description: 'Lunes',
        value: 1,
        selected: false,
      },
      {
        id: 1,
        name: 'M',
        description: 'Martes',
        value: 2,
        selected: false,
      },
      {
        id: 2,
        name: 'M',
        description: 'Miércoles',
        value: 3,
        selected: false,
      },
      {
        id: 3,
        name: 'J',
        description: 'Jueves',
        value: 4,
        selected: false,
      },
      {
        id: 4,
        name: 'V',
        description: 'Viernes',
        value: 5,
        selected: false,
      },
      {
        id: 5,
        name: 'S',
        description: 'Sábado',
        value: 6,
        selected: false,
      },
      {
        id: 6,
        name: 'D',
        description: 'Domingo',
        value: 0,
        selected: false,
      },
    ],
  }),
  computed: {
    typeSpaceOptions() {
      return [
        {
          id: 1,
          name: 'Disponible',
          value: typeSpace.Available,
          label: 'Disponible',
          checked: true,
        },
        {
          id: 2,
          name: 'No Disponible',
          value: typeSpace.Unavailable,
          label: 'No Disponible',
          checked: false,
        },
      ];
    },
    availableHoursOptions() {
      return [
        {
          id: 1,
          name: 'Regular',
          value: availableHours.Regular,
          label: 'Regular',
          checked: true,
        },
        {
          id: 2,
          name: 'Personalizado',
          value: availableHours.Custom,
          label: 'Personalizado',
          checked: false,
        },
      ];
    },
    hasDaysSelected() {
      return this.days?.filter((e) => e.selected == true).length > 0;
    },
    timeOptions() {
      return [
        { value: 'am', text: 'AM' },
        { value: 'pm', text: 'PM' },
      ];
    },
    daysSelected() {
      return (
        this.model.daysSelected.map((e) => {
          if (!e.model) {
            return {
              ...e,
              model: {
                from: {
                  hour: null,
                  minute: null,
                  ampm: null,
                },
                to: {
                  hour: null,
                  minute: null,
                  ampm: null,
                },
              },
            };
          } else {
            return {
              ...e,
            };
          }
        }) || []
      );
    },
    isCustom() {
      return this.model?.availableHours?.id == availableHours.Custom;
    },
    isRegular() {
      return this.model?.availableHours?.id == availableHours.Regular;
    },
    isDisabled() {
      return (model) => {
        return model?.ampmDisabled || false;
      };
    },
  },
  watch: {
    from: {
      handler: function(val) {
        this.handleSet(val, 'model.from');
      },
      deep: true,
    },
    to: {
      handler: function(val) {
        this.handleSet(val, 'model.to');
      },
      deep: true,
    },
    modelEdit: {
      handler: function(val) {
        if (val.length) this.loadModel();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.isMobile) {
      const backdrop = document.createElement('div');
      backdrop.classList.add('backdrop-blur');
      document.body.appendChild(backdrop);
      let backdropBlur = document.querySelector('.backdrop-blur');
      backdropBlur.style.display = 'block';
    }
    this.model.typeSpace = this.typeSpaceOptions[0];

    if (this.modelEdit?.length) {
      this.loadModel();
    }
  },
  beforeDestroy() {
    const backdrops = document.querySelectorAll('.backdrop-blur');
    backdrops.forEach((backdrop) => {
      document.body.removeChild(backdrop);
    });
  },
  methods: {
    handleCheck() {
      this.model.daysSelected = this.days
        .filter((e) => e.selected == true)
        .map((e) => ({
          day: e.value,
          dayName: e.description,
          model: this.model?.daysSelected.length
            ? this.configTime(e.value)
            : {
                from: {
                  hour: null,
                  minute: null,
                  ampm: null,
                },
                to: {
                  hour: null,
                  minute: null,
                  ampm: null,
                },
              },
        }));
    },
    handleSet(value, prop) {
      const props = prop.split('.');
      const [key, property] = props;

      if (this.model?.availableHours?.id == typeSpace.Regular) {
        if (key == 'from') {
          this.from[property] = value;
        }

        if (key == 'to') {
          this.to[property] = value;
        }
      }

      this.model.daysSelected.forEach((e) => {
        let targetObj = e;
        for (let i = 0; i < props.length - 1; i++) {
          if (targetObj[props[i]] === undefined) {
            targetObj[props[i]] = {};
          }
          targetObj = targetObj[props[i]];
        }
        targetObj[props[props.length - 1]] = value;
      });
    },
    async save() {
      this.submitted = true;
      const isValid = await this.$refs.formRef.validate();
      if (!isValid || this.model?.daysSelected.length == 0) {
        this.ShowToast('', 'Información Incompleta', 'error');
        return;
      }

      for (const day of this.model.daysSelected) {
        const isValidTimeRange = this.validateTimeRange(
          day.model.from,
          day.model.to
        );
        const isValidGratherThan = this.validateGreaterthan(
          day.model.from,
          day.model.to
        );
        if (!isValidTimeRange) {
          this.ShowToast(
            '',
            `El horario seleccionado para ${
              this.isCustom ? day.dayName : 'el día'
            } no está dentro del rango válido (7 am - 8 pm).`,
            'error'
          );
          return;
        }

        if (!isValidGratherThan) {
          this.ShowToast(
            '',
            `El horario seleccionado para ${
              this.isCustom ? day.dayName : 'el día'
            } no es válido.`,
            'error'
          );
          return;
        }
      }

      this.$emit('save', this.model);
    },
    close() {
      this.submitted = false;
      this.model = {
        typeSpace: this.typeSpaceOptions[0],
        availableHours: null,
        daysSelected: [],
      };
      this.days.forEach((e) => (e.selected = false));
      this.$emit('close');
    },
    evalEnterHour(date) {
      const { from } = date;
      if (from.hour) {
        const valueHour = parseInt(from.hour);
        const ampmResult = this.getAmPm(valueHour);

        from.ampmDisabled = ampmResult.disabled;
        from.ampm = ampmResult.time;

        this.evalEndHour(date);
      }
    },
    evalEndEnterHour(date) {
      const { to } = date;
      if (to.hour) {
        const valueHour = parseInt(to.hour);
        if ([9, 10, 11].includes(valueHour)) {
          to.ampm = 'am';
          return;
        }
        to.ampm = 'pm';
      }
    },
    evalEnterMinute(date) {
      this.evalEndHour(date);
    },
    evalEnterAmPm() {
      this.evalEndHour();
    },
    evalEnterEndDate() {
      if (this.model.endDateHour)
        this.model.endDateHour = parseInt(this.model.endDateHour);
      if (this.model.endDateMinute)
        this.model.endDateMinute = parseInt(this.model.endDateMinute);

      let resultAmPm = this.getAmPm(this.model.endDateHour);
      this.model.endDateAmPm = resultAmPm.time;
      this.model.endDateAmPmDisabled = resultAmPm.disabled;
    },
    evalEndHour(date) {
      const { from } = date;
      if (from.hour && from.minute && from.ampm) {
        const isHourValid = this.isHourValid(from);
        if (isHourValid) {
          this.setEndHour(date);
        } else {
          from.hour = '';
        }
      }
    },
    isHourValid(startDateHour) {
      if (startDateHour.hour && startDateHour.minute && startDateHour.ampm) {
        const hour = parseInt(startDateHour.hour, 10);
        const minute = startDateHour.minute;
        const ampm = startDateHour.ampm;

        const _isValid = moment(
          `${hour}:${minute} ${ampm}`,
          'h:mm A',
          false
        ).isValid();

        return _isValid;
      }
    },
    isHourEndOverLimit(hour) {
      const from = moment(hour, 'hh:mm A');
      const to = moment('7:00 pm', 'hh:mm A');
      return from.isAfter(to);
    },
    getAmPm(valueHour) {
      let result = { time: 'am', disabled: true };
      if (valueHour == 12 || (valueHour >= 1 && valueHour <= 6)) {
        result.time = 'pm';
      } else if (valueHour >= 7 && valueHour <= 11) {
        result.time = 'am';
      } else {
        result.disabled = false;
      }
      return result;
    },
    setEndHour(date) {
      const { from, to } = date;
      if (!this.isHourValid(from)) {
        to.hour = '';
        return;
      }

      const hour = this.eval24Hour(from.ampm, parseInt(from.hour));
      const minute = parseInt(from.minute) || 0;
      const endDate = moment(new Date()).set({
        hour: hour,
        minute: this.getQuater(minute),
      });
      const amOrPmText = endDate.format('h:mm a').split(' ')[1];
      to.ampm = amOrPmText;
    },
    eval24Hour(ampm, hour) {
      let output = hour;
      if (ampm == 'pm') {
        if (hour != 12) {
          output = hour + 12;
        }
      } else if (ampm == 'am') {
        if (hour == 12) {
          output = 0;
        }
      }
      return output;
    },
    get12HoursFormat(ampm, hour, minute) {
      let output = hour;
      if (ampm == 'pm' && hour > 12) {
        output = hour - 12;
        if (minute >= 45) output = output >= 11 ? output - 11 : output + 1;
      }
      if (ampm == 'pm' && hour <= 12) {
        if (minute >= 45) output = output >= 11 ? output - 11 : output + 1;
      }

      return output;
    },
    getQuater(minutes) {
      let result = 0;
      if (minutes >= 0 && minutes <= 14) {
        result = 15;
      } else if (minutes >= 15 && minutes <= 29) {
        result = 30;
      } else if (minutes >= 30 && minutes <= 44) {
        result = 45;
      } else if (minutes >= 45 && minutes <= 59) {
        result = '00';
      }
      return result;
    },
    objIsValid(obj) {
      if (!obj || typeof obj !== 'object') {
        return false;
      }

      const result = Object.keys(obj).every(
        (prop) =>
          obj[prop] !== null && obj[prop] !== '' && obj[prop] !== undefined
      );

      return result;
    },
    configTime(day) {
      const validFrom = this.objIsValid(this.from);
      const validTo = this.objIsValid(this.to);
      if (this.isRegular && validFrom && validTo) {
        return {
          from: {
            hour: this.from.hour,
            minute: this.from.minute,
            ampm: this.from.ampm,
          },
          to: {
            hour: this.to.hour,
            minute: this.to.minute,
            ampm: this.to.ampm,
          },
        };
      } else if (this.isCustom) {
        return (
          this.model.daysSelected.find((x) => x.day == day)?.model || {
            from: {
              hour: null,
              minute: null,
              ampm: null,
            },
            to: {
              hour: null,
              minute: null,
              ampm: null,
            },
          }
        );
      }
    },
    validateTimeRange(from, to) {
      const startTime = moment(
        `${from.hour}:${from.minute} ${from.ampm}`,
        'h:mm A'
      );
      const endTime = moment(`${to.hour}:${to.minute} ${to.ampm}`, 'h:mm A');
      const startLimit = moment('7:00 am', 'h:mm A');
      const endLimit = moment('8:00 pm', 'h:mm A');

      return (
        startTime.isBetween(startLimit, endLimit, null, '[]') &&
        endTime.isBetween(startLimit, endLimit, null, '[]')
      );
    },
    validateGreaterthan(from, to) {
      const startTime = moment(
        `${from.hour}:${from.minute} ${from.ampm}`,
        'h:mm A'
      );
      const endTime = moment(`${to.hour}:${to.minute} ${to.ampm}`, 'h:mm A');
      return startTime.isBefore(endTime);
    },
    changeAvailableHours() {
      if (this.isCustom) {
        this.model.daysSelected = this.model.daysSelected.map((e) => {
          if (!e.model) {
            return {
              ...e,
              model: {
                from: {
                  hour: null,
                  minute: null,
                  ampm: null,
                },
                to: {
                  hour: null,
                  minute: null,
                  ampm: null,
                },
              },
            };
          } else {
            return {
              ...e,
            };
          }
        });
      }
    },
    loadModel() {
      const convertTo12HourFormat = (date) => {
        const hours = date.getHours();
        const isAM = hours < 12 || hours === 24;
        const hour12 = hours % 12 || 12;
        const minutes = date.getMinutes();
        return {
          hour: hour12,
          minute: minutes < 10 ? `0${minutes}` : minutes,
          ampm: isAM ? 'am' : 'pm',
        };
      };

      const daysSelectedTemp = this.modelEdit.map((x) => {
        const startDate = new Date(x.startDate);
        const endDate = new Date(x.endDate);

        return {
          day: x.day,
          dayName: this.days.find((w) => w.value == x.day).name,
          model: {
            from: convertTo12HourFormat(startDate),
            to: convertTo12HourFormat(endDate),
          },
        };
      });

      const typeSpace = this.typeSpaceOptions?.find(
        (e) => e.value == this.modelEdit[0].typeSpace
      );

      const availableHoursId = this.hasObjectsWithDifferentTimes(
        daysSelectedTemp
      )
        ? availableHours.Custom
        : availableHours.Regular;

      const availableHoursValue = this.availableHoursOptions?.find(
        (e) => e.value == availableHoursId
      );

      if (availableHoursId == availableHours.Regular) {
        this.from = daysSelectedTemp[0].model.from;
        this.to = daysSelectedTemp[0].model.to;
      }

      this.model.typeSpace = typeSpace;
      this.model.availableHours = availableHoursValue;

      Array.from(
        this.$refs.availableHoursRef.$el.childNodes[
          this.$refs.availableHoursRef.$el.childNodes.length - 1
        ].children
      )
        .map((e) => e.children[0])
        .find((e) => e.value == availableHoursId).checked = true;

      this.days = this.days.map((d) => {
        if (daysSelectedTemp.find((x) => x.day == d.value)) {
          return {
            ...d,
            selected: true,
          };
        } else {
          return {
            ...d,
            selected: false,
          };
        }
      });
      this.model.daysSelected = [...daysSelectedTemp];
    },
    areTimeValuesDifferent(time1, time2) {
      return (
        time1.hour !== time2.hour ||
        time1.minute !== time2.minute ||
        time1.ampm !== time2.ampm
      );
    },

    hasDifferentTimeValues(obj1, obj2) {
      return (
        this.areTimeValuesDifferent(obj1.model.from, obj2.model.from) ||
        this.areTimeValuesDifferent(obj1.model.to, obj2.model.to)
      );
    },

    hasObjectsWithDifferentTimes(data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = i + 1; j < data.length; j++) {
          if (this.hasDifferentTimeValues(data[i], data[j])) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

.dot {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  display: inline-block;
  top: 268px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
}
.modal-dialog {
  position: absolute;
  z-index: 1;
  top: 2rem;
  min-width: 25.688rem !important;
  left: calc(100% - 41rem) !important;
}

@media (max-width: 768px) {
  .modal-dialog {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    margin: 0 !important;
    top: auto !important;
    z-index: 99999999;
    min-width: 100% !important;
  }
}

.scrollable {
  overflow-y: scroll;
  max-height: 950px !important;
  height: 600px !important;
}

.modal-header {
  box-shadow: 0px 3px 6px #00000029;
}

.modal-content {
  box-shadow: 0px 2px 8px rgb(0 0 0 / 35%);
}

.modal-title > div {
  padding: 5px 10px;
  border: 3px solid white;
  border-radius: 30px;
  box-shadow: 0px 3px 6px #00000029;
  background: map-get($colors, 'orange');
}

.modal-footer {
  border-top: 0px;
  width: 100%;
  box-shadow: 0px 0px 10px #0000001a;
}

.input-time-size {
  width: 50px;
  margin-right: 10px;
}
.input-time-ampm-size {
  width: 80px;
  margin-right: 10px;
}

::v-deep input[type='checkbox']:checked + label span {
  background-color: map-get($colors, 'green') !important;
}

::v-deep input[type='checkbox']:checked + label span em {
  filter: brightness(0) invert(1);
}

::v-deep div.student-search-alert-error {
  position: absolute;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
  border-radius: 4px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px white;
  border-radius: 10px;
  height: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: map-get($colors, 'secondary-35');
  border-radius: 4px;
  height: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: map-get($colors, 'secondary-35');
  border-radius: 4px;
  height: 5px;
}

::-webkit-scrollbar-button {
  height: 5px !important;
}

.custom-badge {
  background: #d7e0dc !important;
  color: #11291b !important;
}
</style>
